// Environment configuration
// Slug is sourced from domain API (organization-branding-context), not from env.
export const ENV_CONFIG = {
  NODE_ENV: process.env.NODE_ENV || "development",
  BUILD_ENV: process.env.REACT_APP_ENV || "development",
  IKPEC_HOME_URL:
    process.env.REACT_APP_IKPEC_HOME_URL ||
    "https://www.ikpec.or.kr/m2/index_main.asp",
};

// Validate required environment variables
export const validateEnvironment = () => {
  const warnings: string[] = [];
  if (warnings.length > 0) {
    console.warn("Environment validation warnings:", warnings);
  }
  return warnings;
};

// Initialize environment validation
validateEnvironment();
